<template>
  <div class="page-historical-data">
    <div class="query-bar">
      <div class="query-left">
        <el-form inline>
          <el-form-item label="区域筛选">
            <el-select
              class="form-select"
              clearable
              popper-class="form-select-dropdown"
              :popper-append-to-body="false"
              v-model="queryForm.townCode"
              placeholder="全部"
              @change="handlePageChange(1)"
            >
              <el-option
                v-for="item in regionList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="问题状态" label-width="110px">
            <el-select
              class="form-select"
              clearable
              popper-class="form-select-dropdown"
              :popper-append-to-body="false"
              v-model="queryForm.processStatus"
              placeholder="全部"
              @change="handlePageChange(1)"
            >
              <el-option
                v-for="item in problemStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="query-right">
        <TabBar
          :list="timeTabs"
          v-model="queryForm.timeType"
          @change="handleTabChage"
        />
        <el-date-picker
          :clearable="false"
          class="form-time-select"
          v-model="queryForm.date"
          type="daterange"
          placeholder="选择日期"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          popper-class="form-time-select-dropdown form-time-picker-dropdown"
          @focus="queryForm.timeType = '4'"
          @change="handlePageChange(1)"
        ></el-date-picker>
      </div>
    </div>
    <ClipBox class="teble-wrapper">
      <ComTable :columns="columns" :data="tableData">
        <template #index="{ index }">
          <span>
            {{ index + 1 + (pageProps.page - 1) * pageProps.pageSize }}
          </span>
        </template>
        <template #image="{ data }">
          <img class="image" :src="data.eventImg" />
        </template>
        <template #status="{ data }">
          <span :style="{ color: data.statusColor }">
            {{ data.statusName }}
          </span>
        </template>
        <template #operation="{ data }">
          <el-link type="primary" @click="handleDetail(data)">查看详情</el-link>
        </template>
      </ComTable>
    </ClipBox>
    <div class="pagination-wrapper">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="pageProps.page"
        :page-size="pageProps.pageSize"
        :total="pageProps.total"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <DetailDialog :visible.sync="showDetail" :info="rowInfo" />
  </div>
</template>

<script>
  import TabBar from "@/views/RealTimeScheduling/DataScreen/common/TabBar.vue";
  import ComTable from "./ComTable.vue";
  import ClipBox from "@/components/ClipBox/index.vue";
  import DetailDialog from "./DetailDialog.vue";
  import { townshipList } from "@/utils/common";
  import { changeDateTab } from "@/utils/time";
  import { getFireWarningListPage } from "@/api/dataCenter";
  export default {
    name: "HistoricalData",
    components: { TabBar, ComTable, ClipBox, DetailDialog },
    data() {
      return {
        regionList: townshipList,
        problemStatus: [
          { label: "未处理", value: 1 },
          { label: "已处理", value: 2 },
          { label: "已超时-未处理", value: 3 },
          { label: "已超时-已处理", value: 4 },
        ],
        timeTabs: [
          { label: "今日", value: "0" },
          { label: "本月", value: "2" },
          { label: "今年", value: "3" },
          { label: "自定义", value: "4" },
        ],
        queryForm: {
          townCode: "",
          processStatus: "",
          timeType: "0",
          date: [],
        },
        pageProps: {
          page: 1,
          pageSize: 20,
          total: 0,
        },
        columns: [
          {
            prop: "index",
            label: "序号",
            width: "10%",
            slot: "index",
          },
          {
            prop: "warningPoint",
            label: "报警区域",
            width: "15%",
          },
          {
            prop: "procesTime",
            label: "时间",
            width: "20%",
          },
          {
            prop: "gridName",
            label: "区域负责人",
            width: "15%",
          },
          {
            prop: "eventImg",
            label: "照片",
            width: "20%",
            slot: "image",
          },
          {
            prop: "statusName",
            label: "问题状态",
            width: "10%",
            slot: "status",
          },
          {
            prop: "operation",
            label: "操作",
            width: "10%",
            slot: "operation",
          },
        ],
        tableData: [],
        showDetail: false,
        rowInfo: {},
      };
    },
    created() {
      this.handleTabChage("0");
    },
    methods: {
      getData() {
        const {
          townCode,
          processStatus,
          date: [startTime, endTime],
        } = this.queryForm;
        const params = {
          page: this.pageProps.page,
          pageSize: this.pageProps.pageSize,
          townCode,
          processStatus,
          startTime,
          endTime,
        };

        getFireWarningListPage(params).then((res) => {
          this.pageProps.page = res.data.currPage;
          this.pageProps.total = res.data.totalCount;
          const list = res.data.list || [];
          this.tableData = list.map((item) => {
            const { processFlag, overtimeFlag } = item;
            let statusColor = "#1890FF";
            if (processFlag === 0) {
              statusColor = "#FF3400";
            } else if (overtimeFlag === 1) {
              statusColor = "#FC6002";
            }
            return {
              ...item,
              statusColor,
            };
          });
        });
      },
      handleTabChage(type) {
        const date = changeDateTab(type);
        if (date) {
          this.queryForm.date = date;
          this.handlePageChange(1);
        }
      },
      handlePageChange(page) {
        this.pageProps.page = page;
        this.getData();
      },
      handleDetail(row) {
        this.rowInfo = row;
        this.showDetail = true;
      },
    },
  };
</script>

<style scoped lang="less">
  .page-historical-data {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .query-bar {
    height: 62px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .query-right {
      display: flex;
      align-items: center;
    }

    &::v-deep {
      .el-form-item {
        margin-bottom: 0;
      }
      .el-form-item__label {
        font-size: 18px;
        color: #ffffff;
      }
      .el-select .el-input__inner {
        height: 40px;
        width: 200px;
      }
      .el-range-editor.el-input__inner {
        width: 300px;
        height: 34px;
        padding: 0 10px;
      }
      .tab-bar {
        height: 34px;
        margin-right: 22px;
        .tab-item {
          min-width: 66px;
          padding: 0 5px;
          font-size: 16px;
          line-height: 16px;
        }
      }
    }
  }

  .teble-wrapper {
    width: 100%;
    height: 0;
    flex: auto;

    .image {
      width: 288px;
      height: 114px;
    }
  }

  .pagination-wrapper {
    padding: 8px 0 15px;
    text-align: center;

    &::v-deep {
      .el-pagination__total {
        font-size: 20px;
        color: #1890ff;
      }
      .el-pager li {
        min-width: 26px;
        height: 26px;
        line-height: 24px;
        font-weight: 400;
        font-size: 20px;
        color: #1890ff;
        background: transparent;
        border: 1px solid transparent;
      }
      .el-pager li.active {
        box-shadow: inset 0px 0px 9px 0px #00b2ff;
        border-radius: 2px;
        border: 1px solid #1890ff;
      }
      .el-pagination .btn-next,
      .el-pagination .btn-prev {
        background: none;
        color: #1890ff;
      }
      .el-pagination button:disabled {
        color: #1890ff;
        opacity: 0.6;
      }
      .el-pagination button,
      .el-pagination span:not([class*="suffix"]) {
        height: 26px;
        line-height: 26px;
      }

      .el-pagination__jump {
        display: inline-flex;
        align-items: center;
        font-size: 20px;
        color: #1890ff;
      }
      .el-pagination__editor {
        height: auto;
      }
      .el-pagination__editor .el-input__inner {
        width: 47px;
        min-width: 47px;
        height: 32px;
        font-size: 20px;
        color: #1890ff;
        background: none;
        box-shadow: inset 0px 0px 9px 0px #00b2ff;
        border-radius: 2px;
        border: 1px solid #1890ff;
      }
    }
  }
</style>
